const minHeight = typeof window !== 'undefined' && window.innerHeight
const minWidth = typeof window !== 'undefined' && window.innerWidth

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textField: {
    marginRight: theme.spacing.unit * 2,
    display: 'block',
    minWidth: minWidth / 2
  },
  block: {
    display: 'block'
  },
  modal: {
    maxWidth: minWidth / 1.5
  },
  modalHeader: {
    fontWeight:'600!important',
    fontSize: '1.2rem!important',
  },
  logo: {
    height: '50px',
    maxHeight: '50px',
    backgroundColor: 'grey',
    border: '1px solid white',
    display: 'inline-block'
  },
  LogoMissing: {
    width: '50px',
    height: '50px',
    maxHeight: '50px',
    maxWidth: '50px',
    backgroundColor: 'grey',
    border: '1px solid white',
    display: 'inline-block'
  },
  logoButton: {
    width: '20px',
    height: '20px',
    minHeight: '20px',
    position: 'relative',
    top: '-40px',
    left: '-10px'
  },
  logoButtonAdd : {
    backgroundColor : theme.palette.success
  },
  logoButtonRemove : {
    backgroundColor : theme.palette.secondary.dark
  },
  logoButtonIcon: {
    fontSize: '8pt'
  },
  form: {
    maxHeight: minHeight / 2,
    overflowY: 'scroll'
  },
  button: {
    marginLeft: theme.spacing.unit * 2
  },
  submit: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor:  theme.palette.accent,
    color:'white',
  },
  close: {
    padding:0,
    minWidth:40,
  },
  error: {
    background: theme.palette.secondary.main,
    color: theme.palette.common.white,
    textAlign: 'center'
  }
})

export default styles
